module.exports = __webpack_public_path__ + "img/care-offer-3.b6ba3ef6.jpg";